/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Start_Chat_SubtitleInputs */



/**
* | output |
* | --- |
* | "Create a new chat or select an existing project" |
*
* @param {Form_Start_Chat_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_start_chat_subtitle = /** @type {((inputs?: Form_Start_Chat_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Start_Chat_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstelle einen neuen Chat oder wähle ein bestehendes Projekt")
	return /** @type {LocalizedString} */ ("Create a new chat or select an existing project")
});